import { useLocation } from "react-router-dom";
import { backFor, readOrigins } from "../data/backLinks";

// The back link for the page on screen (see data/backLinks).
export default function useBackLink(fallback) {
  const { key, pathname } = useLocation();
  return backFor(readOrigins()[key], fallback, pathname);
}
